module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_front_title_pastel-ebbd28a26935a85727acfe8b32c688eb.svg";